import { IonButtons } from "@ionic/react";
import { forwardRef } from "react";
import { usePreferredHaptics } from "@/lib/hooks/use-preferred-haptics";

export const Buttons = forwardRef<HTMLIonButtonsElement, React.ComponentProps<typeof IonButtons>>(
  function Buttons(props, ref) {
    const PreferredHaptics = usePreferredHaptics();

    return (
      <IonButtons
        ref={ref}
        {...props}
        onClick={(event) => {
          PreferredHaptics.impact();
          props.onClick?.(event);
        }}
      />
    );
  },
);
